module.exports = __webpack_public_path__ + "media/images/beauty/agnes@2x-e8344d61f386664ef87e7d469794b790.jpg";